import { Constants } from "@eagerdog/constants";

/**
 * UKC Conformation is scored at the show level (breed → group → Best in Show), not
 * per entry, so it bypasses the per-score `SCORING_STRATEGIES` registry on both web
 * and mobile. Only UKC conformation shows use this flow.
 */
export function isConformationScoringSupported(
  sanctioningClub: string | undefined,
  showType: string | undefined
): boolean {
  return (
    sanctioningClub === Constants.sanctioning_club.UKC &&
    showType === Constants.show_type.conformation
  );
}

/** Sentinel `scoreId` sent on `score_updated` when a conformation PUT saves the show. */
export const CONFORMATION_SCORE_UPDATED_ID = "conformation";
